import script from "./Sources.vue?vue&type=script&setup=true&lang=js"
export * from "./Sources.vue?vue&type=script&setup=true&lang=js"

import "./Sources.vue?vue&type=style&index=0&id=938c3ff2&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-938c3ff2"]])

export default __exports__